import React from "react";
import GalleryImage from "../components/GalleryImage";

const Gallery = () => {
  return (
    <div>
      <GalleryImage />
    </div>
  );
};

export default Gallery;
